(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sevenera-pearl-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sevenera-pearl-details')) {
    customElements.define('sevenera-pearl-details', class extends HTMLElement {
      connectedCallback() {
        this.handleMetalChange = this.handleMetalChange.bind(this);
        this.scope = this.closest('.shopify-section') || document;
        this.scope.addEventListener('change', this.handleMetalChange);
        this.updateMetal(this.dataset.metal || '14K Yellow Gold');
      }
      disconnectedCallback() {
        this.scope?.removeEventListener('change', this.handleMetalChange);
      }
      handleMetalChange(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.dataset.optionName !== 'Gold Color') return;
        const picker = input.closest('variant-picker');
        if (picker?.dataset.productId !== this.dataset.productId) return;
        this.updateMetal(input.value);
      }
      updateMetal(metal) {
        const isWhite = metal.includes('White');
        this.dataset.metal = metal;
        this.querySelector('[data-backing-yellow]').hidden = isWhite;
        this.querySelector('[data-backing-white]').hidden = !isWhite;
        this.querySelector('[data-backing-property]').value = metal + ' butterfly push backs';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sv-footer-contact"] && !Shopify.designMode) return;
  try {
    (function () {
  function init() {
    document.querySelectorAll('[data-sv-live-chat], a[href="#sv-live-chat"]').forEach(function (button) {
      if (button.dataset.svChatReady) return;
      button.dataset.svChatReady = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var footer = button.closest('.sv-system-footer') || document.querySelector('.sv-system-footer');
        var fallback = footer && footer.querySelector('[data-sv-chat-fallback]');
        function showFallback() {
          if (!fallback) return;
          fallback.hidden = false;
          var details = fallback.querySelector('details');
          if (details) details.open = true;
          var summary = fallback.querySelector('summary');
          if (summary) summary.focus();
        }
        var chat = document.querySelector('shopify-chat');
        if (!chat || !window.customElements || !window.customElements.get('shopify-chat')) { showFallback(); return; }
        try {
          if (typeof chat.show === 'function') {
            Promise.resolve(chat.show()).catch(showFallback);
          } else {
            chat.setAttribute('mode', 'standalone');
            chat.setAttribute('open', '');
          }
        } catch (error) { showFallback(); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sv-macro"] && !Shopify.designMode) return;
  try {
    (function(){
  function matchCard(root){
    var reference=root.querySelector('.sv-bridal-slide');
    var target=root.querySelector('.sv-macro-slide');
    if(!reference||!target||target.dataset.svSizeMatched)return;
    target.dataset.svSizeMatched='true';
    function update(){
      var height=reference.getBoundingClientRect().height;
      if(height>0)target.style.setProperty('--sv-macro-card-height',height+'px');
    }
    update();
    if(window.ResizeObserver){
      var observer=new ResizeObserver(update);
      observer.observe(reference);
    }else{window.addEventListener('resize',update);}
    reference.querySelectorAll('img').forEach(function(img){img.addEventListener('load',update);});
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(update);
  }
  function init(){document.querySelectorAll('.sv-home').forEach(matchCard);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
